import { useMemo } from "react";
import usePermissions from "hooks/usePermissions";
export const ALERTS_EVENTS_STREAMS = ["000000000000000000000003", "000000000000000000000002"];
const usePermittedAlertsEventsStreams = () => {
  const { isPermitted } = usePermissions();
  return useMemo(
    () => ALERTS_EVENTS_STREAMS.filter((streamId) => isPermitted(`streams:read:${streamId}`)),
    [isPermitted]
  );
};
export default usePermittedAlertsEventsStreams;
